export default __webpack_public_path__ + "static/service-2-75941ac2951281b971a090f0455ad82c.jpg";